import React from "react";
import {
  calculatePrice,
  calculateTotal,
  getCurrencySymbol,
} from "../../utilities/utilities.ts";

import { changeItemQuantity, removeItem } from "./cartSlice.ts";
import { CartProps } from "../../types/cart.d.ts";
export const Cart = ({ cart, currencyFilter, dispatch }: CartProps) => {
  const onQuantityChangeHandler = (name: string, newQuantity: number) => {
    dispatch(changeItemQuantity(name, newQuantity));
  };

  const onRemoveItemHandler = (name: string) => {
    dispatch(removeItem(name));
  };

  const cartEntries = Object.entries(cart).filter(
    ([, item]) => item.quantity > 0
  );

  const cartElements = cartEntries.map(createCartItem);

  const itemCount = cartEntries.reduce((total, [, item]) => {
    return total + item.quantity;
  }, 0);

  const total = calculateTotal(cart, currencyFilter);

  return (
    <div id="cart-container">
      <div className="cart-header">
        <h2>Cart</h2>
        <p className="cart-item-count">
          {itemCount} item{itemCount === 1 ? "" : "s"}
        </p>
      </div>

      {cartEntries.length === 0 ? (
        <p className="cart-empty-message">
          Your cart is empty. Add a product to see it here.
        </p>
      ) : (
        <>
          <ul id="cart-items">{cartElements}</ul>
          <h3 className="total">
            Total{" "}
            <span className="total-value">
              {getCurrencySymbol(currencyFilter)}
              {total} {currencyFilter}
            </span>
          </h3>
        </>
      )}
    </div>
  );

  function createCartItem([
    itemName,
    item,
  ]: [string, { price: number; quantity: number }]) {
    const quantity = item.quantity;

    return (
      <li key={itemName} className="cart-item">
        <div className="cart-item-copy">
          <p className="cart-item-name">{itemName}</p>
          <p className="cart-item-price">
            {getCurrencySymbol(currencyFilter)}
            {calculatePrice(item.price, currencyFilter).toFixed(2)}{" "}
            {currencyFilter}
          </p>
        </div>

        <div className="cart-item-controls">
          <div className="quantity-selector">
            <button
              type="button"
              className="quantity-button"
              onClick={() => onQuantityChangeHandler(itemName, quantity - 1)}
              aria-label={`Decrease quantity of ${itemName}`}
            >
              -
            </button>
            <span className="item-quantity">{quantity}</span>
            <button
              type="button"
              className="quantity-button"
              onClick={() => onQuantityChangeHandler(itemName, quantity + 1)}
              aria-label={`Increase quantity of ${itemName}`}
            >
              +
            </button>
          </div>

          <button
            type="button"
            className="remove-item-button"
            onClick={() => onRemoveItemHandler(itemName)}
          >
            Remove
          </button>
        </div>
      </li>
    );
  }
};
